import React from "react";

const EnumsContext = React.createContext({
  enums: {},
  setEnum: (key, data) => {},
  resetEnum: (key) => {}
});

export default EnumsContext;